<script>
  import isTokenValid from "@/utils/validation/is-token-valid/index";
  import GlobeIcon from "@/components/partials/icons/Globe.vue";
  import SupportIcon from "@/components/partials/icons/Support.vue";

  export default {
    components: {
      GlobeIcon,
      SupportIcon,
    },
    props: {},
    computed: {
      isLoggedIn() {
        return isTokenValid()
      },

      getLang() {
        return this.$i18n.locale;
      },

      isRevGatePartner() {
        return process.env.VUE_APP_NAME === "revgate"
      },

      isMobileView() {
        return this.$root.windowWidth < 991;
      },

      logoPath() {
        if (this.isRevGatePartner) return require("@/assets/icons/revgateLogos/main-logo.svg")

        return require("@/assets/icons/boostinyLogos/boostinyWordLogo.svg")
      },
      isPartnerDomain() {
        return process.env.VUE_APP_PARTNER_HOST_NAME === window.location.hostname
      },

      supportEmail() {
        return process.env.VUE_APP_SUPPORT_EMAIL || ""
      },
    },
    methods: {
      goToSignIn() {
        this.$router.push({ name: "login" });
      },

      toggleLang() {
        window.toggleLang();
      },
    },
  };
</script>

<template>
  <div
    class="
      w-100
      d-flex
      justify-content-between
      align-items-center
      h-100
      bg-base-white
    "
  >
    <router-link to="/">
      <img
        :alt="$root.appName"
        :src="logoPath"
        :width="$root.windowWidth >= 768 ? 150 : 100"
        height="30"
      >
    </router-link>

    <div v-if="!isLoggedIn" class="d-flex justify-content-between align-items-center">
      <div
        class="d-flex align-items-center gap-12 p-base-medium"
      >
        <div
          class="d-flex align-items-center cursor-pointer gap-3 text-neutral-700"
          @click="toggleLang"
        >
          <GlobeIcon v-if="!isMobileView" color="var(--neutral-700)" />
          <p class="text-uppercase">
            {{ getLang === "ar" ? "EN" : "AR" }}
          </p>
        </div>
        <a
          v-if="isPartnerDomain && supportEmail"
          :href="`mailto:${supportEmail}`"
          class="d-flex align-items-center gap-3 bg-primary-25 p-base-small radius-4 p-6 cursor-pointer text-primary-500 text-decoration-none"
        >
          <span><SupportIcon color="var(--primary-500)" /></span>
          <span v-if="!isMobileView">{{ $t("buttons.contactSupport") }}</span>
        </a>

        <button class="btn-sm bg-base-white border-full-1 border-neutral-300 p-x-24 cursor-pointer" @click="goToSignIn">
          <span>{{ $t("buttons.login") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
</style>
